module.exports = __webpack_public_path__ + "img/students_banner_bg_mob.65ba72fc.jpg";